module.exports = __webpack_public_path__ + "static/media/Pile_of_Coins@3x.e52d9a9c.png";